import React from 'react'

import { Container, Row, Col } from 'reactstrap'

import ReactHtmlParser from 'react-html-parser'
import data from '../data/faq.json'
import WithLocale from '../hocs/WithLocale'
import useTranslation from '../hooks/UseTranslation'
import { translate } from '../translations/utils'

export async function getStaticProps({ locale, defaultLocale }) {
  return {
    props: {
      nav: {
        light: true,
        classes: 'shadow',
        color: 'white'
      },
      locale,
      defaultLocale,
      title: translate('faq_page_title', locale, defaultLocale)
    }
  }
}

const Faq = () => {
  const { t } = useTranslation()
  const groupByN = (n, data) => {
    const result = []
    for (let i = 0; i < data.length; i += n) result.push(data.slice(i, i + n))
    return result
  }
  return (
    <section className='py-6'>
      <Container>
        <div className='d-flex justify-content-between align-items-end'>
          <h1 className='hero-heading text-first-letter'>
            {t('faq_page_title')}
          </h1>
        </div>
        {data.questionGroups &&
          data.questionGroups.map((group) => {
            const groupedQuestions =
              group.questions &&
              groupByN(group.questions.length / 2, group.questions)
            return (
              <div key={group.title} className='py-4'>
                <h2 className='mb-5 text-primary'>{t(group.title)}</h2>
                <Row>
                  {groupedQuestions.map((questions) => (
                    <Col md='6' key={questions[0].title}>
                      {questions.map((question) => (
                        <React.Fragment key={question.title}>
                          <h5 id={question.id} className='scroll-margin-top'>
                            {ReactHtmlParser(t(question.title))}
                          </h5>
                          <div
                            className='text-muted mb-4'
                            dangerouslySetInnerHTML={{
                              __html: t(question.content)
                            }}
                          />
                        </React.Fragment>
                      ))}
                    </Col>
                  ))}
                </Row>
              </div>
            )
          })}
      </Container>
    </section>
  )
}

export default WithLocale(Faq)
